{
    "grass": {
        "id": "grass",
        "label": "Grass",
        "spriteId": "boundaries--grass",
        "hasFloors": false,
        "sameOnBothSides": true
    },
    "fence": {
        "id": "fence",
        "label": "Empty lot",
        "spriteId": "boundaries--fenced-lot",
        "hasFloors": false
    },
    "parking-lot": {
        "id": "parking-lot",
        "label": "Parking lot",
        "spriteId": "boundaries--parking-lot",
        "hasFloors": false,
        "repeatHalf": true,
        "offsetY": 0.15
    },
    "waterfront": {
        "id": "waterfront",
        "label": "Waterfront",
        "spriteId": "boundaries--waterfront",
        "waterfront": true,
        "hasFloors": false,
        "alignAtBaseline": true,
        "repeatHalf": true
    },
    "waterfront2": {
        "id": "waterfront2",
        "label": "Waterfront",
        "spriteId": "boundaries--waterfront2",
        "waterfront": true,
        "hasFloors": false,
        "alignAtBaseline": true,
        "repeatHalf": true,
        "earthColor": "#366387"
    },
    "residential": {
        "id": "residential",
        "label": "Home",
        "spriteId": "buildings--residential",
        "hasFloors": true,
        "variantsCount": 0,
        "floorHeight": 3,
        "roofHeight": 2,
        "mainFloorHeight": 7.25
    },
    "narrow": {
        "id": "narrow",
        "label": "Building",
        "spriteId": "buildings--apartments-narrow",
        "hasFloors": true,
        "variantsCount": 1,
        "floorHeight": 3,
        "roofHeight": 0.7,
        "mainFloorHeight": 4.1,
        "overhangWidth": 16
    },
    "wide": {
        "id": "wide",
        "label": "Building",
        "spriteId": "buildings--apartments-wide",
        "hasFloors": true,
        "variantsCount": 1,
        "floorHeight": 3,
        "roofHeight": 0.7,
        "mainFloorHeight": 4.1,
        "overhangWidth": 21.5
    },
    "arcade": {
        "id": "arcade",
        "label": "Arcade building",
        "spriteId": "buildings--arcade",
        "hasFloors": true,
        "variantsCount": 1,
        "floorHeight": 3.1,
        "roofHeight": 1.8,
        "mainFloorHeight": 4.1,
        "overhangWidth": 15
    },
    "compound-wall": {
        "id": "compound-wall",
        "label": "Compound wall",
        "spriteId": "boundaries--compound-wall",
        "hasFloors": false
    },
    "beach": {
        "id": "beach",
        "label": "Beach",
        "spriteId": "boundaries--beach",
        "waterfront": true,
        "hasFloors": false,
        "alignAtBaseline": true,
        "repeatHalf": true,
        "earthColor": "#ecdbb1"
    },
    "marsh": {
        "id": "marsh",
        "label": "Marsh",
        "spriteId": "boundaries--marsh",
        "waterfront": true,
        "hasFloors": false,
        "alignAtBaseline": true,
        "repeatHalf": true
    },
    "water": {
        "id": "water",
        "label": "Water",
        "spriteId": "boundaries--water",
        "waterfront": true,
        "hasFloors": false,
        "alignAtBaseline": true,
        "repeatHalf": true,
        "earthColor": "#366387"
    },
    "dock": {
        "id": "dock",
        "label": "Dock",
        "spriteId": "boundaries--dock",
        "waterfront": true,
        "hasFloors": true,
        "showFloors": false,
        "variantsCount": 1,
        "floorHeight": 0.25,
        "roofHeight": 3,
        "mainFloorHeight": 1.75,
        "alignAtBaseline": true,
        "earthColor": "#366387"
    },
    "fishing-boat": {
        "id": "fishing-boat",
        "label": "Fishing boat",
        "spriteId": "boundaries--fishing-boat",
        "waterfront": true,
        "alignAtBaseline": true,
        "repeatHalf": true,
        "earthColor": "#366387"
    },
    "cargo-ship": {
        "id": "cargo-ship",
        "label": "Cargo ship",
        "spriteId": "boundaries--cargo-ship",
        "waterfront": true,
        "alignAtBaseline": true,
        "earthColor": "#366387"
    }
}
